export const MAIN_NAVIGATION_HEIGHT = 81;
export const FULL_HEIGHT_CONTENT_STYLE = {
  height: `calc(100vh - ${MAIN_NAVIGATION_HEIGHT}px)`,
};

export const TAB_LINKS_NAVIGATION_HEIGHT = 62;
